export const SET_DOMAIN_GROUPS = 'SET_DOMAIN_GROUPS';
export const SET_CURRENT_DOMAIN_GROUP = 'SET_CURRENT_DOMAIN_GROUP';
export const SET_PAGINATION = 'SET_PAGINATION';



// WEBPACK FOOTER //
// ./src/store/modules/domain-groups/types.js